import { useCallback, useEffect, useRef, useState } from 'react'
import { createExportListScheduler } from './exportListScheduler'

const EMPTY_EXPORTS = []

export const useExportListPolling = ({ apiBase, authHeaders, enabled }) => {
  const [result, setResult] = useState(null)
  const [failure, setFailure] = useState(null)
  const schedulerRef = useRef(null)

  useEffect(() => {
    if (!enabled) return

    const scheduler = createExportListScheduler({
      request: (signal) => fetch(`${apiBase}/exports`, { headers: authHeaders, signal }),
      onUpdate: (items) => {
        setResult({ apiBase, authHeaders, items })
        setFailure(null)
      },
      onError: () => setFailure({ apiBase, authHeaders })
    })
    schedulerRef.current = scheduler
    scheduler.refresh()

    return () => {
      scheduler.stop()
      schedulerRef.current = null
    }
  }, [apiBase, authHeaders, enabled])

  const refresh = useCallback(() => {
    schedulerRef.current?.refresh()
  }, [])

  // Hide the previous tenant/session's list until this scope has been loaded.
  const exports = enabled && result?.authHeaders === authHeaders && result.apiBase === apiBase
    ? result.items
    : EMPTY_EXPORTS

  const error = Boolean(enabled && failure?.authHeaders === authHeaders && failure.apiBase === apiBase)

  return { exports, refresh, error }
}
